export default __webpack_public_path__ + "static/media/popup_woz.f6856e59.png";